export enum Path {
    // Public
    Home = '',
    NotFound = '404',

    // Auth
    Auth = 'auth',
    Login = 'login',
    SignUp = 'signup',
    ForgotPassword = 'auth/forgot-password',
    ResetPassword = 'auth/reset-password',
    Patient = "patient",
    ChangePassword = 'user/change-password',
    UserDashboard = 'user/user-dashboard',

    // App base url
    Website = "",

 
    Dashboard = 'dashboard',
    User = 'user',



}
